import { DataAnalyticsService } from './../../services/data-analytics.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
@Component({
  selector: 'app-factory-selection-modal',
  templateUrl: './factory-selection-modal.component.html',
  styleUrls: ['./factory-selection-modal.component.scss']
})
export class FactorySelectionModalComponent implements OnInit {

  factorySelectionForm: UntypedFormGroup;
  clusterList: any[] = [];
  factoryList: any[] = [];
  fileredClusterList: any[] = [];
  filteredFactoryList: any[] = [];
  isSelected: boolean;
  subscriptionMessage: string;
  uniqueClusterList: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataPassed,
    public fb: UntypedFormBuilder,
    public dialog: MatDialogRef<FactorySelectionModalComponent>,
    private daService: DataAnalyticsService
  ) { }

  ngOnInit() {
    this.factorySelectionForm = this.fb.group({
      cluster: [null, [Validators.required]],
      factory: [null, [Validators.required]]
    });

    this.f.factory.disable();
    this.clearSelected();
    this.getClusters();
  }

  get f() {
    return this.factorySelectionForm.controls;
  }
  /* istanbul ignore next */
  autoCompleteCluster(event: string) {
    this.f.factory.setValue('');
    this.f.factory.disable();
    if (event && event !== '') {
      const searchKeyword = event.toLowerCase();
      // const clonedClusterList = [...this.clusterList];
      this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.clusterId, m])).values()];
      this.uniqueClusterList = this.uniqueClusterList.filter(c => {
        if (c.name.toLowerCase().includes(searchKeyword)) {
          return true;
        }
      });
    } else {
      this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.clusterId, m])).values()];
      this.filteredFactoryList = this.factoryList;
      this.isSelected = false;
    }
  }

  autoCompleteFactory(event: string) {
    this.isSelected = false;
    if (event && event !== '') {
      const searchKeyword = event.toLowerCase();
      const clonedFactoryList = [...this.factoryList];
      this.filteredFactoryList = clonedFactoryList.filter(f => {
        if (f.name.toLowerCase().includes(searchKeyword)) {
          return true;
        }
      });
    } else {
      this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.clusterId, m])).values()];
      this.filteredFactoryList = this.factoryList;
    }
  }

  getClusters() {
    const clusters = JSON.parse(sessionStorage.getItem('dfos.userfactory.data'));
    if (clusters) {
      this.clusterList = this.fileredClusterList = clusters;
      this.uniqueClusterList = [];
      this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.clusterId, m])).values()];
      if (clusters.length === 1) {
        this.onClusterChange(clusters[0]);
      }
    }
  }
  /* istanbul ignore next */
  getFactories(cluster: any) {
    this.factoryList = this.filteredFactoryList = [];
    for (let index = 0; index < this.fileredClusterList.length; index++) {
      if (this.fileredClusterList[index].name === cluster.name) {
        this.fileredClusterList.forEach((entry) => {
          entry.factoryList.forEach(element => {
            element['id'] = entry.id;
            element['subRegionName'] = entry.name;
          });
        });

        this.factoryList = this.filteredFactoryList = [...this.factoryList, ...this.fileredClusterList[index].factoryList];
      }

    }
    this.factoryList.sort((a, b) => a.name.localeCompare(b.name));
  }

  clearSelected() {
    sessionStorage.removeItem('selectedDACluster');
    sessionStorage.removeItem('selectedDAFactory');
  }
  onClusterChange(cluster: any) {
    this.f.cluster.setValue(cluster.name);
    sessionStorage.setItem('selectedDACluster', JSON.stringify(cluster));
    this.f.factory.setValue('');
    this.f.factory.enable();
    this.getFactories(cluster);
  }

  onFactoryChange(factory: any) {
    this.f.factory.setValue(factory.name);
    sessionStorage.setItem('selectedDAFactory', JSON.stringify(factory));
    this.isSelected = true;
    this.subscriptionMessage = '';
  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  onSubmit() {
    if (this.factorySelectionForm.valid) {
      sessionStorage.setItem('selectedDACluster', JSON.stringify(this.filteredFactoryList[0]));
      this.dialog.close(
        {
          action: 'submitted',
          selectedData: this.factorySelectionForm.value,
          selectedClusterId: this.filteredFactoryList[0].id
        }
      );
    }
  }

  dialogClose() {
    this.dialog.close({ action: 'cancelled' });
  }

}
